import type { AssistTagTone } from './assist.types'

/**
 * Tag pill shared by Copilot cards (suggestion categories and answer source
 * labels). Geometry and colours come from the Copilot content design: 10px
 * medium text in a 4px-radius chip, neutral slate for categories and warm amber
 * for Backlog results.
 */
const TONE_CLASS: Record<AssistTagTone, string> = {
  neutral: 'bg-[#f1f5f9] text-[#475569] dark:bg-white/10 dark:text-[var(--text-tertiary)]',
  backlog: 'bg-[#fffbeb] text-[#b45309] dark:bg-amber-500/10 dark:text-amber-400',
}

type AssistTagPillProps = {
  label: string
  tone: AssistTagTone
}

export default function AssistTagPill({ label, tone }: AssistTagPillProps) {
  return (
    <span
      className={`shrink-0 rounded-[4px] px-2 py-0.5 text-[10px] font-medium leading-4 ${TONE_CLASS[tone]}`}
      data-testid="copilot-tag-pill"
      data-tone={tone}
    >
      {label}
    </span>
  )
}
